import { SVGProps, Ref, forwardRef } from 'react';

export const ArrowsDiagonalInOutlinedSize24Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="m22 3.273-5.464 5.463h4.828v1.8h-7.9v-7.9h1.8v4.828L20.727 2zM2.636 13.463h7.9v7.9h-1.8v-4.827L3.273 22 2 20.727l5.464-5.463H2.636z"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
ArrowsDiagonalInOutlinedSize24Glyph.displayName = 'ArrowsDiagonalInOutlinedSize24Glyph';
